const bowlList = [
    {
        id: 0,
        title: "October Acacia, 2018",
        image: require("./assets/bowl-1.webp"),
        measurement: '5.7cm x 36.2cm',
        description: 'white clay, chrome oxide, clear glaze'

    },
    {
        id: 1,
        title: "Flamboyant, 2022",
        image: require("./assets/bowl-2.webp"),
        measurement: '6.1cm x 38.7 cm',
        description: 'white clay, iron oxide, clear glaze, black glaze'

    },
    {
        id: 2,
        title: "Oumou, 2022",
        image: require("./assets/bowl-3.webp"),
        measurement: '8.3cm x 43.2',
        description: 'white clay, copper oxide, iron oxide, clear glaze'

    },
    {
        id: 3,
        title: "Cucumber, 2022",
        image: require("./assets/bowl-4.webp"),
        measurement: '6.5cm x 31.6cm',

        description: 'anthracite stoneware, copper oxide, blue slip, clear glaze'

    },
    {
        id: 4,
        title: "Field’s Edge, 2021",
        image: require("./assets/bowl-5.webp"),
        measurement: '4cm x 29cm',
        description: 'terracotta, copper oxide, clear glaze'

    },
    {
        id: 5,
        title: "November Acacia, 2017",
        image: require("./assets/bowl-7.webp"),
        measurement: '4.8cm x 35.7cm',
        description: 'black clay, white slip, clear glaze'

    },
    {
        id: 6,
        title: "Nathalie, 2019",
        image: require("./assets/bowl-8.webp"),
        measurement: '15.2cm x 42.9cm',
        description: 'white clay, cobalt oxide, copper oxide, clear glaze'

    },
    {
        id: 7,
        title: "Ayesha, 2019",
        image: require("./assets/bowl-9.webp"),
        measurement: '3.1cm x 27.9cm',
        description: 'white clay, copper oxide, lead glaze'

    },
    {
        id: 8,
        title: "Pond, 2021",
        image: require("./assets/bowl-10.webp"),
        measurement: '6cm x 36.7cm',
        description: 'terracotta, white slip, green lead glaze'

    },
    

]

export default bowlList;